/* MASTERPIECE — FUTURE SITE layer (every page + funnels) */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var inEditor = !!(w.Shopify && w.Shopify.designMode);
  var isHome = d.body && d.body.classList.contains('template-index');

  function onScroll() {
    var bar = d.querySelector('.mfx-progress');
    if (!bar) { bar = d.createElement('div'); bar.className = 'mfx-progress'; bar.setAttribute('aria-hidden', 'true'); d.body.appendChild(bar); }
    var tick = false;
    function upd() {
      var h = html.scrollHeight - innerHeight;
      bar.style.setProperty('--p', h > 0 ? Math.min(scrollY / h, 1) : 0);
      html.classList.toggle('fx-scrolled', scrollY > 40);
      tick = false;
    }
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  function tilt(el, max) {
    if (el.dataset.fxTilt) return; el.dataset.fxTilt = '1';
    var raf = 0;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        el.classList.add('is-tilting');
        el.style.setProperty('--ry', ((x - .5) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((.5 - y) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--hx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--hy', (y * 100).toFixed(1) + '%');
      });
    });
    el.addEventListener('pointerleave', function () { cancelAnimationFrame(raf); el.classList.remove('is-tilting'); el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
  }
  function tilts(root) {
    if (reduce || !fine) return;
    (root || d).querySelectorAll('.product-card__media, .mw-card__media, .mp-card__media').forEach(function (el) { tilt(el, 6); });
  }

  var FRAMES = [
    ['.mp-hero__media', 'MP // LIVE DROP'],
    ['.mind-hero', 'MIND // SIGNAL ON'],
    ['.mmlp-hero', 'MIX + MATCH // ONLINE'],
    ['.mw-vault', 'VAULT // ACCESS'],
    ['body.template-collection [id$="__main-collection-banner"]', 'COLLECTION // SCAN'],
    ['body.template-search .section--padding:first-child', 'SEARCH // QUERY']
  ];
  function frames() {
    FRAMES.forEach(function (f) {
      d.querySelectorAll(f[0]).forEach(function (el) {
        if (el.querySelector(':scope > .fx-hud-frame')) return;
        if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
        var fr = d.createElement('div'); fr.className = 'fx-hud-frame'; fr.setAttribute('aria-hidden', 'true');
        fr.innerHTML = '<i></i><i></i><i></i><i></i><b>' + f[1] + '</b>';
        el.appendChild(fr);
      });
    });
  }

  function reveal() {
    if (isHome || reduce || inEditor || !('IntersectionObserver' in w)) return;
    var els = d.querySelectorAll('.mp-card, .mm-card, .mw-card, .mw__head, .mp-sec-head');
    if (!els.length) return;
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fx-in'); io.unobserve(e.target); } }); }, { threshold: .1, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) {
      if (el.hasAttribute('data-fx-r')) return;
      var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.setAttribute('data-fx-r', ''); el.style.setProperty('--fx-i', Math.min(idx % 4, 4));
      if (el.getBoundingClientRect().top < innerHeight) el.classList.add('fx-in'); else io.observe(el);
    });
    html.classList.add('fx-site-armed');
    setTimeout(function () { d.querySelectorAll('[data-fx-r]').forEach(function (el) { el.classList.add('fx-in'); }); }, 6000);
  }

  function init() {
    onScroll();
    tilts();
    frames();
    reveal();
    if ('MutationObserver' in w && fine && !reduce) {
      var pending = false;
      new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; tilts(); }, 400); })
        .observe(d.body, { childList: true, subtree: true });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function (e) { tilts(e.target); frames(); });
})();
